import React from 'react'
import { compose, lifecycle, setDisplayName } from 'recompose'
import NotificationProvider, {
  type ProviderProps
} from './NotificationProvider'
import Notification from '../../ui/notifications/notification'

const NotificationFactory = (props: ProviderProps) => {
  const { notification, ...uiProps } = props
  if (!notification) return null
  return (
    <Notification
      iconName='notifications'
      className='fixed-bottom'
      {...uiProps}
    >
      {props.text}
    </Notification>
  )
}

const withAutomaticHiding = lifecycle({
  componentDidUpdate() {
    // injected by Notification Provider
    const { hideDelay, notification, dismissNotification } = this.props
    if (hideDelay && notification) {
      if (this._timeout) clearTimeout(this._timeout)
      this._timeout = setTimeout(() => {
        dismissNotification(notification.id)
      }, hideDelay)
    }
  }
})

const decorate = compose(
  setDisplayName('NotificationFactory'),
  NotificationProvider,
  withAutomaticHiding
)

export default decorate(NotificationFactory)



// WEBPACK FOOTER //
// ./src/services/notification/notification-factory.js